<template>
<v-card max-width="340px" class="rounded-card">
    <v-img height="60px" :src="typeImg" class="teal-background">
      <v-card-title class="mb-0 py-0 bottom-title" :class="titleColor" >{{feed.code}} - {{feed.name}}</v-card-title>
    </v-img>
    <!-- <v-card-text class="py-1">
      <span>Type: </span>
      <span class="font-weight-medium">{{feed.feedType}}</span>
    </v-card-text> -->
    <v-layout>
      <v-flex xs9>
        <v-card-text class="py-1 ps-2">
          <span>{{$t('Load Tolerance')}}: </span>
          <span class="font-weight-medium">{{feed.tolerance | kgString}}</span>
        </v-card-text>
      </v-flex>
      <v-flex xs3>
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-icon right color="orange darken-1 pe-6" v-on="on" v-if="feed.manLoad">
              mdi-hand-right
            </v-icon>
          </template>
          <span>{{$t('Manual Loading Item')}}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 md5>
        <v-card-text class="py-1 px-2">
          <span>{{$t('Value')}}: </span>
          <span class="font-weight-medium">{{formatValue(feed.value)}}</span>
        </v-card-text>
      </v-flex>
      <v-flex xs10 md5>
        <v-card-text class="py-1 px-2">
          <span>{{$t('Dry Mat')}}: </span>
          <span class="font-weight-medium">{{feed.dryMaterial * 100}}%</span>
        </v-card-text>
      </v-flex>
      <v-flex xs2 md2>
        <v-btn icon @click.stop="edit()" class="pa-0 ma-0 pb-8" small>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-icon color="primary" v-on="on">mdi-square-edit-outline</v-icon>
            </template>
            <span>{{$t('Edit feed') + " " + feed.name}}</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <AddEditFeed v-bind:value.sync="showDialog" v-bind:feedId="feedId" v-on:close="close" />

    <v-layout wrap>
      <v-flex xs12 md10>
        <v-card-text class="py-1 px-2">
          <span>{{$t('Inventory Level')}}: </span>
          <span class="font-weight-medium">{{feed.invQty | kgString}}</span>
        </v-card-text>
      </v-flex>
    </v-layout>
</v-card>
</template>

<script>
import AddEditFeed from "../components/AddEditFeed";
export default {
  name: "feedPanel",
  props: ["feedId"],
  data()  {
    return {
      showDialog: false,
      FeedTypeImg: [
        { text: '', img: "ft_grass.jpg", color: "white--text"},
        { text: 'Unspecified', img: "ft_grass.jpg", color: "white--text"},
        { text: 'Premix', img: "ft_premix.jpg", color: "white--text"},
        { text: 'Silage', img: "ft_silage.jpg", color: "white--text"},
        { text: 'Roughage ', img: "ft_grass.jpg", color: "white--text"},
        { text: 'Cereal grains', img: "ft_maize.jpg", color: "black--text"},
        { text: 'Cereal byproducts', img: "ft_brewers_grains.jpg", color: "white--text"},
        { text: 'Legumes and oilseeds', img: "ft_peas.jpg", color: "white--text"},
        { text: 'Oil byproducts', img: "ft_soybean_meal.jpg", color: "indigo--text"},
        { text: 'Roots and byproducts', img: "ft_beet_pulp.jpg", color: "white--text"},
        { text: 'Fruits and byproducts', img: "ft_citrus.jpg", color: "black--text"},
        { text: 'Other plant products', img: "ft_alfalfa_protein.jpg", color: "white--text"},
        { text: 'Animal products', img: "ft_fish_meal.jpg", color: "white--text"},
        { text: 'Dairy products', img: "ft_milk_powder.jpg", color: "black--text"},
        { text: 'Oils and fats', img: "ft_oil.jpg", color: "white--text"},
        { text: 'Mineral products', img: "ft_calcium_carbonate.jpg", color: "black--text"},
        { text: 'Amino acids', img: "ft_lysine.jpg", color: "orange--text"}
      ]
    }
  },
  computed: {
      feed() {
        return this.$store.getters.getFeed(this.feedId);
      },
      titleColor() {
        return "white--text";
        // if (this.feed.feedType == undefined || this.feed.feedType == '' || this.feed.feedType == 'Unspecified')
        //   return "white--text";
        // var fdType = this.FeedTypeImg.find(t => t.text === this.feed.feedType);
        // return fdType.color;
      },
      typeImg() {
        if (this.feed.feedType == undefined || this.feed.feedType == '' || this.feed.feedType == 'Unspecified')
          return "";
        var fdType = this.FeedTypeImg.find((t) => {
                return t.text === this.feed.feedType;
            })
        var images = require.context("../assets/", false, /\.jpg$/)
        if (fdType)
          return images("./" + fdType.img)
        else
          return "";
      }
  },
  methods: {
    edit() {
      this.showDialog=true;
    },
    close() {
      this.showDialog=false;
    },
    formatValue(value) {
      const currency = this.$store.getters.getCurrency;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, currencyDisplay: 'symbol' }).format(value);
    },
  },
  components: {
     AddEditFeed,
  }

}
</script>

<style>
  .rounded-card {
    border-radius:8px;
  }
  .bottom-title {
    position:absolute;
    bottom:0;
    background: rgba(128,128,128, 0.5);
    /* width: 100%; */
    border-radius: 10px 10px 0 0;
  }
  .teal-background {
    background-color: teal;
  }
</style>
